<div class="col-12">
  <a (click)="onGoBack()"
    class="btn btn--link btn--link--secondary btn--link--secondary--bold btn--link--secondary--big btn--link--secondary--left pl-0">
    <img class=" title-navigation-fix-align" src="assets/img/arrow_l_g.png" alt="">Delegar aprobación</a>
</div>
<div class="col-lg-6 u-mt20" *ngIf="!selectedPersonData">
  <div class="box u-mb60 no-padding no-margin">
    <app-select-list title="Persona a delegar" hintText="*El rut debe ser sin puntos y con guión"
      (textInputValueEmitter)="onSearchPersonTextChange($event)" [optionList]="listPersonOptions"
      placeHolder="Buscar por nombre, rut* o email" (selectedValueEmitter)="onSearchPersonSelected($event)"
      [isLoading]="loadingPersonOptions"
    >
    </app-select-list>
  </div>
</div>


<div class="row" *ngIf="!!selectedPersonData">
  <div class="col-12 col-lg-9">
    <!-- <div class="child-no-bottom-margin-padding"> -->
    <app-person-card class="child-no-bottom-margin-padding" imageDimensions="tiny" [personData]="selectedPersonData"
      [boxColor]="boxColor">
    </app-person-card>
    <!-- </div> -->
    <div class="col-12 ">
      <a class="back back--small global-hand" (click)="onUnselect()">
        Buscar otra persona
      </a>
    </div>
  </div>
  <div class="col-12 col-lg-3 mt-4">
    <div class="form">
      <app-text-area [controlForm]="noteFormControl" [whitePanel]="true" title="Comentario" placeholder="Ingresa"
        [maxlength]="300">
      </app-text-area>
    </div>
  </div>
</div>

<div class="col-12 u-mt20 mb-2">
  <button *ngIf="!selectedPersonData" type="button" class=" btn btn--primary modal__trigger px-4 "
    [ngClass]="controlForm.controls.id.value > 0 ? '' : 'btn--disabled'" (click)="onSelectPerson()">
    Buscar perfil
  </button>
  <button *ngIf="selectedPersonData" type="button" class="btn btn--primary modal__trigger px-4" (click)="onSubmit()">
    Delegar
  </button>
</div>
